module.exports = __webpack_public_path__ + "img/129.7.dde4d2d6.png";